<template>
  <section
    id="solution"
    ref="solutionRef"
    class="solution transition-all duration-1000 ease-out landing-container py-120px lt-sm:py-120px lt-sm:px-0"
    :class="[isSolutionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-50px']"
  >
    <div class="solution-header text-center mb-45px">
      <h2
        class="solution-title font-s-36px font-semibold text-#000000 mb-4px lh-60px lt-sm:font-s-48px lt-sm:lh-60px"
      >
        物业管理正面临这些挑战
      </h2>
      <p
        class="solution-desc font-s-16px text-main/70 lh-30px lt-sm:font-s-24px lt-sm:px-110px lt-sm:mt-16px lt-sm:lh-40px"
      >
        传统物业管理模式效率低下、成本高昂、服务体验差，急需数字化转型
      </p>
    </div>

    <div
      ref="solutionListRef"
      class="solution-list flex h-365px w-full gap-24px lt-sm:h-auto lt-sm:gap-16px lt-sm:overflow-x-auto lt-sm:overflow-y-hidden lt-sm:px-24px lt-sm:[scroll-snap-type:x_mandatory] lt-sm:[scrollbar-width:none]"
      @scroll="handleSolutionScroll"
    >
      <div
        v-for="(solution, index) in solutions"
        :key="solution.id"
        class="solution-card relative flex h-full overflow-hidden rounded-24px will-change-[transform,opacity] transition-all duration-600 transition-[transform:cubic-bezier(0.34,1.56,0.64,1),opacity:ease,flex:ease-in-out,background-color:ease-in-out] lt-sm:flex-[0_0_90%] lt-sm:min-h-750px lt-sm:w-630px lt-sm:[scroll-snap-align:center] lt-sm:rounded-24px"
        :class="[
          index === activeIndex
            ? 'active bg-[linear-gradient(0deg,#E5E9F5_0%,#EFF2FB_100%)] lt-sm:scale-100 lt-sm:opacity-100'
            : 'bg-[linear-gradient(180deg,#E8F6FD_50.48%,#A5D7FD_100%)] lt-sm:bg-[linear-gradient(0deg,#E5E9F5_0%,#EFF2FB_100%)] lt-sm:scale-96 lt-sm:opacity-50',
        ]"
        @mouseenter="activeIndex = index"
        @click="scrollToSolution(index)"
      >
        <div
          class="solution-card-hover h-full w-full pt-40px px-48px absolute left-0 top-0 transition-all ease-in-out lt-sm:relative lt-sm:pt-40px lt-sm:px-36px lt-sm:pb-32px lt-sm:opacity-100 lt-sm:translate-y-0 lt-sm:pointer-events-auto"
          :class="[
            index === activeIndex
              ? 'opacity-100 translate-y-0 duration-500'
              : 'opacity-0 translate-y-20px pointer-events-none duration-300 mobile-show lt-sm:opacity-100 lt-sm:translate-y-0 lt-sm:pointer-events-auto',
          ]"
        >
          <div
            class="solution-card-title pf-sc-semibold text-overflow font-s-22px text-#000000 transition-all lt-sm:font-s-32px"
            :class="[
              index === activeIndex
                ? 'opacity-100 translate-y-0 delay-100 duration-500'
                : 'opacity-0 translate-y-20px delay-0 duration-200',
            ]"
          >
            <span class="lt-sm:hidden">{{ solution.hoverTitle }}</span>
            <h3 class="inline sm:hidden">{{ solution.title }}解决方案</h3>
          </div>
          <div
            class="solution-card-desc pf-sc-regular font-s-14px lh-24px mt-8px text-main/70 pf-sc-regular text-overflow transition-all lt-sm:font-s-24px lt-sm:mt-8px lt-sm:lh-normal"
            :class="[
              index === activeIndex
                ? 'opacity-100 translate-y-0 delay-150 duration-500'
                : 'opacity-0 translate-y-20px delay-0 duration-200',
            ]"
          >
            <p class="text-overflow">{{ solution.hoverDesc }}</p>
          </div>
          <div
            class="solution-card-items mt-24px flex flex-col gap-8px transition-all lt-sm:mt-48px"
            :class="[
              index === activeIndex
                ? 'opacity-100 translate-y-0 delay-400 duration-700'
                : 'opacity-0 translate-y-20px delay-0 duration-300',
            ]"
          >
            <div
              v-for="item in solution.hoverItems"
              :key="item.title"
              class="solution-card-item flex flex-col"
            >
              <div
                class="solution-card-item-header flex gap-8px items-center font-s-14px lt-sm:font-s-24px lt-sm:gap-12px"
              >
                <i class="i-custom-check-one solution-card-item-icon wh-18px lt-sm:wh-32px"></i>
                <div
                  class="solution-card-item-content flex items-center gap-8px lt-sm:flex-col lt-sm:items-start lt-sm:gap-8px"
                >
                  <span class="text-main pf-sc-semibold">
                    {{ item.title }}
                  </span>
                  <span class="text-main/70 pf-sc-regular line-clamp-1">
                    {{ item.itemDesc }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <button
            class="solution-card-btn pf-sc-regular mt-56px h-48px w-268px bg-primary text-white pf-sc-regular rounded-8px px-16px flex items-center justify-between hover:opacity-80 transition-all lt-sm:w-270px lt-sm:h-95px lt-sm:rounded-16px lt-sm:mt-102px"
            :class="[
              index === activeIndex
                ? 'opacity-100 translate-y-0 delay-500 duration-700'
                : 'opacity-0 translate-y-20px delay-0 duration-200',
            ]"
            @click="openConsultation"
          >
            <span class="font-s-16px lt-sm:font-s-26px">立即咨询</span>
            <i class="i-custom-arrow-right wh-18px lt-sm:wh-28px"></i>
          </button>
          <img
            :src="solution.hoverImg"
            :alt="solution.title + '解决方案示意图'"
            loading="lazy"
            class="solution-card-img wh-280px absolute bottom--37px right-0 transition-all duration-300 ease-in-out lt-sm:wh-264px lt-sm:bottom--26px"
            :class="[
              index === activeIndex
                ? 'opacity-100 scale-100 delay-200 duration-500'
                : 'opacity-0 scale-50 delay-0 duration-300',
            ]"
          />
        </div>

        <div
          class="solution-card-normal h-full w-220px pt-40px px-24px absolute left-0 top-0 transition-all ease-in-out lt-sm:hidden"
          :class="[
            index === activeIndex
              ? 'opacity-0 pointer-events-none duration-300'
              : 'opacity-100 duration-500',
          ]"
        >
          <div
            class="solution-card-icon-wrapper wh-40px ml-2px bg-white rounded-10px flex-center transition-all ease-in-out"
            :class="[
              index === activeIndex
                ? 'scale-150 opacity-0 delay-0 duration-300'
                : 'scale-100 opacity-100 delay-0 duration-500',
            ]"
          >
            <img
              :src="solution.img"
              :alt="solution.title + '图标'"
              loading="lazy"
              class="wh-35px"
            />
          </div>

          <div
            class="solution-card-normal-title mt-18px font-s-18px text-main pf-sc-semibold transition-all"
            :class="[
              index === activeIndex
                ? 'opacity-0 translate-y-10px delay-0 duration-200'
                : 'opacity-100 translate-y-0 delay-100 duration-500',
            ]"
          >
            {{ solution.title }}
          </div>
          <div
            class="solution-card-normal-desc mt-8px font-s-14px lh-24px text-main/60 pf-sc-regular w-172px transition-all"
            :class="[
              index === activeIndex
                ? 'opacity-0 translate-y-10px delay-0 duration-200'
                : 'opacity-100 translate-y-0 delay-150 duration-500',
            ]"
          >
            {{ solution.desc }}
          </div>
          <i
            class="i-custom-circle-right-up solution-card-normal-arrow wh-48px absolute bottom-24px left-24px transition-all"
            :class="[
              index === activeIndex
                ? 'opacity-0 scale-50 delay-0 duration-200'
                : 'opacity-100 scale-100 delay-100 duration-500',
            ]"
          ></i>
        </div>
      </div>
    </div>

    <div class="solution-dots lt-sm:flex hidden lt-sm:mt-40px flex-center lt-sm:gap-16px">
      <div
        v-for="(_, index) in solutions"
        :key="index"
        class="dot lt-sm:w-60px lt-sm:h-10px bg-#E5E9F5 rounded-full transition-all cursor-pointer"
        :class="{ active: index === activeIndex }"
        @click="scrollToSolution(index)"
      ></div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { solutions } from '@/constants/common'

  const solutionRef = ref<HTMLElement | null>(null)
  const { isVisible: isSolutionVisible } = useScrollReveal(solutionRef)
  const { openConsultation } = useConsultation()

  const activeIndex = ref(0)
  const solutionListRef = ref<HTMLElement | null>(null)

  const handleSolutionScroll = (e: Event) => {
    const el = e.target as HTMLElement
    const scrollLeft = el.scrollLeft
    const width = el.offsetWidth
    const cardWidth = width * 0.85
    const gap = 16
    const newIndex = Math.round(scrollLeft / (cardWidth + gap))
    if (newIndex !== activeIndex.value) {
      activeIndex.value = newIndex
    }
  }

  const scrollToSolution = (index: number) => {
    if (window.innerWidth >= 640) return
    if (!solutionListRef.value) return

    activeIndex.value = index

    const width = solutionListRef.value.offsetWidth
    const cardWidth = width * 0.85
    const gap = 16
    solutionListRef.value.scrollTo({
      left: index * (cardWidth + gap),
      behavior: 'smooth',
    })
  }
</script>

<style scoped>
  .solution-list::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 768px) {
    .solution-card.active {
      flex: 1 1 0%;
    }
    .solution-card:not(.active) {
      flex: 0 0 220px;
    }
  }

  .solution-card:first-child {
    @apply lt-sm:ml-36px;
  }
  .solution-card:last-child {
    @apply lt-sm:mr-36px;
  }
  @screen lt-sm {
    .dot.active {
      background-color: #0f67f8 !important;
    }
  }
</style>
